module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account-status/send-files/send-files.component.scss
// module id = ./src/app/pages/account-status/send-files/send-files.component.scss
// module chunks = main